// extracted by mini-css-extract-plugin
module.exports = {"root":"Container-module--root--2XdFo"};